<template>
    <div class="header-box" v-if="isShowSibber">
        <div v-for="item in products" :key="item.id">
            <div class="title" :class="{ 'title-left': item.showKey == 2 }" @click.stop="handleClickRoute(item)">
                {{ item.name }}</div>
            <div :class="{ 'product-list': (item.showKey != 2), 'product-next': item.showKey == 2 }">
                <div class="product-item single-line-ellipsis" v-for="(product, index) in item.children" :key="index"
                    :title="product.name" @click.stop="handleClickRoute(product, item.showKey)">
                    {{ product.name }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductList',
    props: {
        isShowSibber: {
            type: Boolean,
            default: true
        },
        products: {
            type: Array,
            default: () => [{
                name: '推荐产品',
                children: [
                    { name: 'WEB3钱包+IM', route: '/product' },
                    { name: 'DAO社区钱包', route: '/product' },
                    { name: '天晟中心化交易所', route: '/product' },
                    { name: 'SE交易所', route: '/product' },
                    { name: '烈焰WEB3去中心化钱包', route: '/product' },
                    { name: 'WEB3生态综合', route: '/product' }
                ]
            }
            ]
        }
    },
    data() {
        return {};
    },
    methods: {
        handleClickRoute(row, showKey) {
            window.scrollTo({ top: 0, behavior: "smooth" });
            const { route, id,click } = row;
            if (click) {
                click()
                this.$emit('updateShowSibber', false);
                return
            }
            if ((route && this.$route.path == route) || typeof route !== 'string' || !route.includes('/')) {
                this.$emit('updateShowSibber', false);
                return
            };
            try {
                if (showKey == 2) {
                    localStorage.setItem("detailForm", JSON.stringify(row))
                    this.$router.replace({ path: route + '/' + id + "?isApi=false" });
                    return;
                }
                // 在这里可以处理路由跳转，或者执行其他逻辑
                console.log('Navigating to:', route);
                this.$router.replace({ path: route, query: { id } });
                this.$emit('updateShowSibber', false);
            } catch (e) {
                console.log(e);
            }


        }
    }
};
</script>

<style lang="scss" scoped>
.header-box {
    width: 100%;
    top: 69px;
    min-height: 150px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    text-align: center;
    display: flex;
    justify-content: center;
    padding: 20px 0;
    position: fixed;
    z-index: 999;
    background-color: #fff;
}

.title {
    font-size: 18px;
    font-weight: 600;
    padding: 20px 0;
    cursor: pointer;

    &:hover {
        color: #5a91f2;
    }
}

.product-list {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    max-width: 400px;
    min-width: 150px;
    margin: 0 40px;
}

.product-item {
    // background-color: #f0f4ff;
    border-radius: 8px;
    padding: 10px 20px;
    color: black;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.3s;
    flex: 1 1 calc(50% - 15px);
    box-sizing: border-box;
    max-width: 200px;
    min-width: 150px;

    &:hover {
        color: #5a91f2;
        background-color: #f0f4ff;
    }
}

.product-item:hover {
    background-color: #e0e7ff;
}

.product-next {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    .product-item {
        max-width: 100px;
    }
}

.title-left {
    text-align: left;
    margin-left: 20px;
}
</style>